import styled from "styled-components";
import {Colors} from "../../theme/colors";
import * as React from "react";

const BaseP = styled(({ color, ...rest }) => <p {...rest} >{rest.children}</p>)<{color: string}>`
  color: ${props => ((props.color)) ? props.color : Colors.secondary10};
  font-family: Poppins;
  font-weight: 400;
  line-height: 144%;
  font-style: normal;
`;
export const StyledP1 = styled(BaseP)`
  font-size: 1rem;
`;

export const StyledP2 = styled(BaseP)`
  font-size: 0.9rem;
`;

export const StyledP3 = styled(BaseP)`
  font-size: 0.75rem;
`;

export const StyledH1 = styled(({ color, ...rest }) => <h1 {...rest} >{rest.children}</h1>)<{color: string}>`
  color: ${props => ((props.color)) ? props.color : Colors.secondary10};
  font-family: Poppins;
  font-size: 2.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
`;

export const StyledH2 = styled(({ color, ...rest }) => <h2 {...rest} >{rest.children}</h2>)<{color: string}>`
  color: ${props => ((props.color)) ? props.color : Colors.secondary10};
  font-family: Poppins;
  font-size: 2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
`;

export const StyledH3 = styled(({ color, ...rest }) => <h3 {...rest} >{rest.children}</h3>)<{color: string}>`
  color: ${props => ((props.color)) ? props.color : Colors.secondary10};
  font-family: Poppins;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
`;

export const StyledH4 = styled(({ color, ...rest }) => <h4 {...rest} >{rest.children}</h4>)<{color: string}>`
  color: ${props => ((props.color)) ? props.color : Colors.secondary10};
  font-family: Poppins;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
`;

export const StyledH5 = styled(({ color, ...rest }) => <h5 {...rest} >{rest.children}</h5>)<{color: string}>`
  color: ${props => ((props.color)) ? props.color : Colors.secondary10};
  font-family: Poppins;
  font-size: 1.1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
`;

export const StyledH6 = styled(({ color, ...rest }) => <h6 {...rest} >{rest.children}</h6>)<{color: string}>`
  color: ${props => ((props.color)) ? props.color : Colors.secondary10};
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
`;